<script>
  export default {
    name: 'error-view',

    props: {
      code: {
        type: Number,
        required: true
      }
    },

    metaInfo() {
      return {
        title: this.code ? `Error ${this.code}` : 'Error'
      }
    },

    computed: {
      error () {
        let error = {}

        switch (this.code) {
          case 401:
            error = {
              heading: '',
              message: ''
            }
            break
          case 403:
            error = {
              heading: '',
              message: ''
            }
            break
          case 404:
            error = {
              heading: 'Oops, page not found',
              message: 'The page you are looking for could not be found'
            }
            break
          case 500:
            error = {
              heading: '',
              message: ''
            }
            break
          default:
            error = {
              heading: '',
              message: ''
            }
        }

        return error
      },

      bgImage () {
        const backgrounds = [
          '/img/error/error_bg1.jpg',
          '/img/error/error_bg2.jpg',
          '/img/error/error_bg3.jpg',
        ]

        return backgrounds[Math.floor(Math.random() * backgrounds.length)]
      }
    }
  }
</script>

<template>
  <div class="error-page">
    <div class="bg" :style="{ backgroundImage: `url(${bgImage})` }"></div>
    <div class="wrap">
      <div class="content">
        <h1>{{ code }}</h1>
        <h4>{{ error.heading }}</h4>
        <p>{{ error.message }}</p>
        <p>
          Go back to <router-link to="/">Hive</router-link> or <a href="#">contact us</a> about the problem.
        </p>
      </div>
    </div>
  </div>
</template>

<style src="./ErrorView.scss" lang="scss" scoped></style>
